import * as Yup from 'yup';
import { DeepPartial, FieldNamesMarkedBoolean } from 'react-hook-form';
import { GetPropertyOwnerResponseTO } from 'models/Owner';

export const propertySettingsOwnersTabSchema = () => {
  return Yup.object({
    communicationSettings: Yup.object({
      ownerUid: Yup.string().required(),
      notes: Yup.string().optional(),
      notes_htmlContent: Yup.string().optional(),
      collectAndRemitTaxes: Yup.string().oneOf(['YES', 'NO']).required(),
      copyOwnerWhenBookingConfirmed: Yup.string()
        .oneOf(['YES', 'NO'])
        .required(),
    }),
  });
};

export type PropertySettingsOwnersTabFormValues = DeepPartial<
  Yup.InferType<ReturnType<typeof propertySettingsOwnersTabSchema>>
>;

export type PropertySettingsPricingTabFormDirtyFields = Partial<
  Readonly<FieldNamesMarkedBoolean<PropertySettingsOwnersTabFormValues>>
>;

export function getFormDefaultValues({
  propertyOwnersData,
}: {
  propertyOwnersData?: GetPropertyOwnerResponseTO | null;
}): PropertySettingsOwnersTabFormValues {
  return {
    communicationSettings: {
      ownerUid: propertyOwnersData?.propertyOwnership?.owner?.uid,
      notes: propertyOwnersData?.propertyOwnership?.ownerNotes ?? '',
      notes_htmlContent:
        propertyOwnersData?.propertyOwnership?.ownerNotes ?? '',
      collectAndRemitTaxes: propertyOwnersData?.propertyOwnership
        .collectAndRemitTaxes
        ? 'YES'
        : 'NO',
      copyOwnerWhenBookingConfirmed: propertyOwnersData?.propertyOwnership
        ?.copyOwnerWhenBookingConfirmed
        ? 'YES'
        : 'NO',
    },
  };
}
